export default {
  getDetail: state => state.detail,
  getFaqList: state => state.faqList,
  getCondition: state => state.condition
};
